import { useLocation, useNavigate } from "react-router-dom";
import { Users, Phone, ShieldCheck, Sparkles, Zap, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const tiles = [
  { icon: Phone, title: "Eine Nummer", desc: "Ein Anruf für alle Anliegen, kein Hin und Her.", bg: "bg-sky" },
  { icon: Users, title: "Ein Team", desc: "Geprüfte Fachkräfte aus einem Netzwerk.", bg: "bg-lavender" },
  { icon: ShieldCheck, title: "Eine Rechnung", desc: "Transparent, gebündelt, nachvollziehbar.", bg: "bg-butter" },
  { icon: Sparkles, title: "Null Stress", desc: "Wir koordinieren, du sparst Zeit.", bg: "bg-rose" },
];

const USPSection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const goToContact = () => {
    if (location.pathname !== "/") return navigate("/#contact");
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-10 md:py-16 bg-muted">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-4 md:gap-5 max-w-6xl mx-auto">
          <div className="md:col-span-6 lg:col-span-6 lg:row-span-2 rounded-2xl md:rounded-3xl p-5 sm:p-7 md:p-10 gradient-mint text-primary-foreground shadow-glow relative overflow-hidden flex flex-col justify-center">
            <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-background/10 blur-3xl pointer-events-none" />
            <span className="inline-flex items-center gap-2 self-start px-3 py-1 rounded-full bg-background/20 backdrop-blur-sm text-sm font-medium mb-4">
              <Sparkles className="w-4 h-4" /> Unser Versprechen
            </span>
            <h2 className="text-3xl md:text-4xl font-outfit font-bold mb-4 leading-tight">
              Ein Ansprechpartner für all deine Dienstleistungen.
            </h2>
            <p className="text-base md:text-lg opacity-95 mb-5 md:mb-6">
              Eine Nummer, ein Team, alle Gewerke. Wir organisieren alles, damit du dich auf das Wesentliche konzentrieren kannst.
            </p>
            <Button onClick={goToContact} size="lg" variant="secondary" className="self-start font-semibold">
              Jetzt unverbindlich anfragen <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>

          {tiles.map((t) => (
            <div key={t.title} className={`md:col-span-3 lg:col-span-3 rounded-2xl md:rounded-3xl p-4 md:p-6 ${t.bg} border border-border/40 hover:-translate-y-1 transition-transform`}>
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-card/80 flex items-center justify-center mb-3 md:mb-4">
                <t.icon className="w-5 h-5 text-primary" />
              </div>
              <h3 className="font-semibold text-lg text-foreground mb-1">{t.title}</h3>
              <p className="text-sm text-muted-foreground">{t.desc}</p>
            </div>
          ))}

          <a
            href="tel:+4915565412425"
            className="md:col-span-6 lg:col-span-12 rounded-2xl md:rounded-3xl p-4 md:p-6 glass-card flex flex-col sm:flex-row sm:items-center gap-3 md:gap-4 justify-between group hover:shadow-card transition-shadow"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-destructive flex items-center justify-center shrink-0 animate-pulse">
                <Zap className="w-6 h-6 text-destructive-foreground" />
              </div>
              <div>
                <p className="font-bold text-foreground text-lg">Elektrotechnik Notdienst</p>
                <p className="text-sm text-muted-foreground">Stromausfall oder defekte Leitung? Wir koordinieren schnell einen Elektriker.</p>
              </div>
            </div>
            <span className="inline-flex items-center gap-2 rounded-xl bg-destructive text-destructive-foreground px-5 py-3 font-semibold group-hover:scale-105 transition-transform">
              <Phone className="w-4 h-4" /> Jetzt anrufen
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default USPSection;
